import * as CONST from "./constants/licence_sub_type_constants";
import {
  COLLECTION_AGENCY_DOCUMENT_TYPES_MAP,
  DEBT_MANAGEMENT_DOCUMENT_TYPES_MAP,
  DOCUMENT_CONTENT_TYPE_DOC,
  DOCUMENT_CONTENT_TYPE_DOCX,
  DOCUMENT_CONTENT_TYPE_PDF,
  DOCUMENT_CONTENT_TYPE_XLS,
  DOCUMENT_CONTENT_TYPE_XLSX,
  DOCUMENT_TYPE_BROKER_COURSE_CERTIFICATE,
  DOCUMENT_TYPE_CRIMINAL_RECORD,
  DOCUMENT_TYPE_EDUCATION_CERTIFICATE,
  DOCUMENT_TYPE_FINANCIAL_STATEMENT_LETTER,
  DOCUMENT_TYPE_FORMS_AGREEMENTS,
  DOCUMENT_TYPE_NOTICES_LETTERS,
  DOCUMENT_TYPE_SURETY_BONDS,
  MORTGAGE_BROKER_DOCUMENT_TYPES_MAP,
  MORTGAGE_BROKERAGE_DOCUMENT_TYPES_MAP,
  MORTGAGE_LENDER_DOCUMENT_TYPES_MAP
} from "./constants";

export const MAX_FILENAME_LENGTH = 128;

export const NOT_ALLOWED_CHARS = ["<", ">", ":", "\\", '"', "/", "\\\\", "|", "?", "*"];

export const fileNameWithLengthLimit = (filename) => {
  if (filename.length > MAX_FILENAME_LENGTH) {
    let fileNameComponents = filename.split(".");

    // reduce the name part and then append the extension again.
    if (fileNameComponents.length === 2) {
      let tName = fileNameComponents[0].substring(
        0,
        MAX_FILENAME_LENGTH - (fileNameComponents[1].length + 1)
      );
      return `${tName}.${fileNameComponents[1]}`;
    } else {
      // if there are more than one '.' in the file name, just trunacate the whole name
      return filename.substring(0, MAX_FILENAME_LENGTH);
    }
  }

  return filename;
};

export const validateFileName = (filename) => {
  return !NOT_ALLOWED_CHARS.some((c) => {
    if (filename.indexOf(c) !== -1) {
      return true;
    }

    return false;
  });
};

export function acceptedFileFormats(documentType) {
  let fileFormats = [];

  switch (documentType) {
    case DOCUMENT_TYPE_SURETY_BONDS:
      fileFormats.push(".jpg");
      fileFormats.push(".png");
      // documents
      fileFormats.push(".doc");
      fileFormats.push(".docx");
      fileFormats.push("application/msword");
      fileFormats.push("application/vnd.openxmlformats-officedocument.wordprocessingml.document");
      // xls
      fileFormats.push(".xls");
      fileFormats.push(".xlsx");
      fileFormats.push("application/vnd.ms-excel");
      fileFormats.push(
        "application/application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      );
      // pdf
      fileFormats.push(".pdf");
      fileFormats.push("application/pdf");
      break;
    //intentionally don't break for the other formats
    case DOCUMENT_TYPE_FORMS_AGREEMENTS:
    case DOCUMENT_TYPE_NOTICES_LETTERS:
    case DOCUMENT_TYPE_FINANCIAL_STATEMENT_LETTER:
    case DOCUMENT_TYPE_CRIMINAL_RECORD:
    case DOCUMENT_TYPE_EDUCATION_CERTIFICATE:
    case DOCUMENT_TYPE_BROKER_COURSE_CERTIFICATE:
    default: {
      // documents
      fileFormats.push(".doc");
      fileFormats.push(".docx");
      fileFormats.push("application/msword");
      fileFormats.push("application/vnd.openxmlformats-officedocument.wordprocessingml.document");
      // xls
      fileFormats.push(".xls");
      fileFormats.push(".xlsx");
      fileFormats.push("application/vnd.ms-excel");
      fileFormats.push(
        "application/application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      );
      // pdf
      fileFormats.push(".pdf");
      fileFormats.push("application/pdf");
    }
  }

  return fileFormats;
}

export function fileTypeEnum(fileType) {
  if (fileType === ".pdf" || fileType === "application/pdf") {
    return DOCUMENT_CONTENT_TYPE_PDF;
  } else if (fileType === "application/msword" || fileType === ".doc") {
    return DOCUMENT_CONTENT_TYPE_DOC;
  } else if (
    fileType === "application/vnd.openxmlformats-officedocument.wordprocessingml.document" ||
    fileType === ".docx"
  ) {
    return DOCUMENT_CONTENT_TYPE_DOCX;
  } else if (fileType === "application/vnd.ms-excel") {
    return DOCUMENT_CONTENT_TYPE_XLS;
  } else if (fileType === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") {
    return DOCUMENT_CONTENT_TYPE_XLSX;
  } else if (fileType === "text/plain") {
    return DOCUMENT_CONTENT_TYPE_DOCX;
  }

  return fileType;
}

export function convertFileDataForUrl(data, documentContentType) {
  switch (documentContentType) {
    case DOCUMENT_CONTENT_TYPE_PDF:
      data = "data:application/pdf;base64," + data;
      break;
    case DOCUMENT_CONTENT_TYPE_XLS:
      data = "data:application/vnd.ms-excel;base64," + data;
      break;
    case DOCUMENT_CONTENT_TYPE_DOC:
      data = "data:application/msword;base64," + data;
      break;
    case DOCUMENT_CONTENT_TYPE_XLSX:
      data =
        "data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64," + data;
      break;
    case DOCUMENT_CONTENT_TYPE_DOCX:
      data =
        "data:application/vnd.openxmlformats-officedocument.wordprocessingml.document;base64," +
        data;
      break;
    default:
      console.warn("unknown document content type - " + documentContentType);
      break;
  }

  return data;
}

export function extractBase64(data) {
  let dataParts = data.split(",");

  if (Array.isArray(dataParts) && dataParts.length === 2) return dataParts[1];

  return data;
}

export function fileSizeReplacement(string, fileSize) {
  return string.replace(/<file_size>/g, fileSize + "MB");
}

export function getDocumentsMapForApplication(application) {
  if (!application) {
    return null;
  }

  switch (application.licencingSubType) {
    case CONST.LICENCE_SUB_TYPE_MORTGAGE_BROKERAGE_NEW_APPLICATION:
    case CONST.LICENCE_SUB_TYPE_MORTGAGE_BROKERAGE_RENEWAL_APPLICATION:
      return MORTGAGE_BROKERAGE_DOCUMENT_TYPES_MAP;

    case CONST.LICENCE_SUB_TYPE_ASSOCIATE_MORTGAGE_BROKER_NEW_APPLICATION:
    case CONST.LICENCE_SUB_TYPE_ASSOCIATE_MORTGAGE_BROKER_RENEWAL_APPLICATION:
    case CONST.LICENCE_SUB_TYPE_MORTGAGE_BROKER_NEW_APPLICATION:
    case CONST.LICENCE_SUB_TYPE_MORTGAGE_BROKER_RENEWAL_APPLICATION:
    case CONST.LICENCE_SUB_TYPE_PRINCIPAL_BROKER_NEW_APPLICATION:
    case CONST.LICENCE_SUB_TYPE_PRINCIPAL_BROKER_RENEWAL_APPLICATION:
    case CONST.LICENCE_SUB_TYPE_INDIVIDUAL_PRINCIPAL_BROKER_RETENTION_APPLICATION:
      return MORTGAGE_BROKER_DOCUMENT_TYPES_MAP;

    case CONST.LICENCE_SUB_TYPE_MORTGAGE_LENDER_NEW_APPLICATION:
    case CONST.LICENCE_SUB_TYPE_MORTGAGE_LENDER_RENEWAL_APPLICATION:
    case CONST.LICENCE_SUB_TYPE_MORTGAGE_ADMINISTRATOR_NEW_APPLICATION:
    case CONST.LICENCE_SUB_TYPE_MORTGAGE_ADMINISTRATOR_RENEWAL_APPLICATION:
    case CONST.LICENCE_SUB_TYPE_INDIVIDUAL_COMPLIANCE_OFFICER_RETENTION_APPLICATION:
      return MORTGAGE_LENDER_DOCUMENT_TYPES_MAP;

    case CONST.LICENCE_SUB_TYPE_COLLECTION_AGENCY_APPLICATION:
    case CONST.LICENCE_SUB_TYPE_COLLECTION_AGENCY_RENEWAL:
      return COLLECTION_AGENCY_DOCUMENT_TYPES_MAP;

    case CONST.LICENCE_SUB_TYPE_DEBT_MANAGEMENT_APPLICATION:
    case CONST.LICENCE_SUB_TYPE_DEBT_MANAGEMENT_RENEWAL:
    case CONST.LICENCE_SUB_TYPE_DEBT_MANAGEMENT_INDIVIDUAL_APPLICATION:
    case CONST.LICENCE_SUB_TYPE_DEBT_MANAGEMENT_INDIVIDUAL_RENEWAL:
      return DEBT_MANAGEMENT_DOCUMENT_TYPES_MAP;

    default:
      return [];
  }
}

export function getDocumentTypeName(documentType) {
  if(MORTGAGE_BROKERAGE_DOCUMENT_TYPES_MAP[documentType]) {
    return MORTGAGE_BROKERAGE_DOCUMENT_TYPES_MAP[documentType];
  }

  if(MORTGAGE_BROKER_DOCUMENT_TYPES_MAP[documentType]) {
    return MORTGAGE_BROKER_DOCUMENT_TYPES_MAP[documentType];
  }

  if(MORTGAGE_LENDER_DOCUMENT_TYPES_MAP[documentType]) {
    return MORTGAGE_LENDER_DOCUMENT_TYPES_MAP[documentType];
  }

  if(COLLECTION_AGENCY_DOCUMENT_TYPES_MAP[documentType]) {
    return COLLECTION_AGENCY_DOCUMENT_TYPES_MAP[documentType];
  }

  if(DEBT_MANAGEMENT_DOCUMENT_TYPES_MAP[documentType]) {
    return DEBT_MANAGEMENT_DOCUMENT_TYPES_MAP[documentType];
  }

  return documentType;
}
